define('shared/util/tracking/pageName',['$', 'shared/lib/RSVP', 'shared/lib/console', 'shared/util/state'], function($, RSVP, console, state){

    'use strict';

    return {
        getConversionPageName: function(){

            var me = this;
            if (me.options && me.options.conversionPageNameSuffix) {
                console.log('tracking/pageName gets suffix: ' + me.options.conversionPageNameSuffix);
                return state.retrieve('page.name')
                    .then(function(pageName){
                        return pageName + ':' +  me.options.conversionPageNameSuffix;
                    });
            }
            else{
                console.log('tracking/pageName plain page.name');
                return state.retrieve('page.name');
            }
        }
    };
});
